import { HappeningPage } from "@features/article";
import { graphql } from "gatsby";
import React from "react";

const News = ({
  data: {
    sanityNews: { _type, _id, content, publishDate, newsTag },
  },
}) => {
  return (
    <HappeningPage
      _type={_type}
      content={content}
      newsTag={newsTag}
      publishDate={publishDate}
      currentArticleId={_id}
    />
  );
};

export const query = graphql`
  query News($id: String) {
    sanityNews(_id: { eq: $id }) {
      _id
      _type
      content {
        title: _rawTitle
        introduction: _rawIntroduction
        body: _rawBody(resolveReferences: { maxDepth: 6 })
        mainImage {
          asset {
            gatsbyImageData(fit: FILLMAX, width: 1200)
          }
          hotspot {
            x
            y
          }
        }
      }
      slug {
        current
      }
      publishDate
      newsTag {
        name: _rawName
      }
    }
  }
`;

export default News;
